import React from "react";
import "./index.scss";

interface WizardStepsProps {
  current: number; // 1-based index of the active step
  steps?: string[];
}

const DEFAULT_STEPS = ["Détails du produit", "Photos"];

const WizardSteps: React.FC<WizardStepsProps> = ({
  current,
  steps = DEFAULT_STEPS,
}) => {
  return (
    <div className="wizard-steps" role="list">
      {steps.map((label, i) => {
        const index = i + 1;
        const state =
          index < current ? "done" : index === current ? "active" : "todo";
        return (
          <React.Fragment key={label}>
            <div className={`wizard-step is-${state}`} role="listitem">
              <span className="wizard-step__dot">
                {state === "done" ? <i className="bx bx-check" /> : index}
              </span>
              <span className="wizard-step__label">{label}</span>
            </div>
            {index < steps.length && <span className="wizard-step__bar" />}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default WizardSteps;
